/* EasyStryde — global.js
   Vanilla JS. Announcement rotator, mobile nav, cart drawer, tabs, FAQ,
   sticky mobile ATC, gallery, variant selection. No dependencies. */
(function () {
  'use strict';

  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2);
  };

  /* ---------- Helpers ---------- */
  function on(sel, evt, fn, root) {
    (root || document).addEventListener(evt, function (e) {
      var t = e.target.closest(sel);
      if (t) fn(e, t);
    });
  }
  function lockScroll(lock) {
    document.body.classList.toggle('overflow-hidden', !!lock);
  }

  /* ---------- Announcement rotator (desktop) ---------- */
  function initAnnouncement() {
    var rot = document.querySelector('[data-announcement-rotator]');
    if (!rot) return;
    var items = rot.querySelectorAll('.announcement__item');
    if (items.length < 2) return;
    var i = 0;
    items.forEach(function (el, idx) { el.style.display = idx === 0 ? 'block' : 'none'; });
    setInterval(function () {
      items[i].style.display = 'none';
      i = (i + 1) % items.length;
      items[i].style.display = 'block';
    }, 4000);
  }

  /* ---------- Mobile nav ---------- */
  function initMobileNav() {
    var nav = document.getElementById('MobileNav');
    var overlay = document.getElementById('NavOverlay');
    if (!nav || !overlay) return;
    function open() { nav.setAttribute('aria-hidden', 'false'); overlay.setAttribute('aria-hidden', 'false'); lockScroll(true); }
    function close() { nav.setAttribute('aria-hidden', 'true'); overlay.setAttribute('aria-hidden', 'true'); lockScroll(false); }
    on('[data-nav-open]', 'click', function (e) { e.preventDefault(); open(); });
    on('[data-nav-close]', 'click', function (e) { e.preventDefault(); close(); });
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Cart drawer ---------- */
  var Cart = {
    drawer: null,
    init: function () {
      this.drawer = document.getElementById('CartDrawer');
      if (!this.drawer) return;
      var self = this;
      on('[data-cart-open]', 'click', function (e) { e.preventDefault(); self.open(); });
      on('[data-cart-close]', 'click', function (e) { e.preventDefault(); self.close(); });
      var ov = this.drawer.querySelector('[data-cart-overlay]');
      if (ov) ov.addEventListener('click', function () { self.close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });
      // remove line
      on('[data-cart-remove]', 'click', function (e, t) {
        e.preventDefault();
        self.change(t.getAttribute('data-cart-remove'), 0);
      });
    },
    open: function () { this.drawer.setAttribute('aria-hidden', 'false'); lockScroll(true); },
    close: function () { this.drawer.setAttribute('aria-hidden', 'true'); lockScroll(false); },
    add: function (id, qty) {
      var self = this;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty || 1 })
      }).then(function (r) { return r.json(); }).then(function () {
        return self.refresh().then(function () { self.open(); });
      });
    },
    change: function (key, qty) {
      var self = this;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function () { return self.refresh(); });
    },
    refresh: function () {
      var self = this;
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); return cart; });
    },
    render: function (cart) {
      // count badges
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });
      var items = this.drawer.querySelector('[data-cart-items]');
      var foot = this.drawer.querySelector('[data-cart-foot]');
      if (!items) return;
      if (cart.item_count === 0) {
        items.innerHTML = '<div class="cart-empty"><p>Your cart is empty.</p><a class="button" href="/collections/all">Shop the Collection</a></div>';
        if (foot) foot.style.display = 'none';
        return;
      }
      if (foot) foot.style.display = '';
      items.innerHTML = cart.items.map(function (it) {
        var img = it.image ? '<img src="' + it.image.replace(/(\.[^.]+)$/, '_120x$1') + '" alt="" width="64" height="64" loading="lazy">' : '<div class="card__placeholder" style="width:64px;height:64px;border-radius:6px"></div>';
        return '<div class="cart-item">' + img +
          '<div><strong>' + it.product_title + '</strong>' +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<div style="opacity:.7;font-size:.85rem">' + it.variant_title + '</div>' : '') +
          '<div>' + money(it.final_price) + ' × ' + it.quantity + '</div>' +
          '<button class="link-underline" data-cart-remove="' + it.key + '" style="font-size:.8rem">Remove</button></div>' +
          '<div>' + money(it.final_line_price) + '</div></div>';
      }).join('');
      var sub = this.drawer.querySelector('[data-cart-subtotal]');
      if (sub) sub.textContent = money(cart.total_price);
    }
  };

  /* ---------- Tabs ---------- */
  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (group) {
      var btns = group.querySelectorAll('[role="tab"]');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          btns.forEach(function (b) {
            var sel = b === btn;
            b.setAttribute('aria-selected', sel ? 'true' : 'false');
            var panel = group.querySelector('#' + b.getAttribute('aria-controls'));
            if (panel) panel.hidden = !sel;
          });
        });
      });
    });
  }

  /* ---------- FAQ / accordion ---------- */
  function initAccordions() {
    on('.faq__q', 'click', function (e, btn) {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) panel.hidden = expanded;
    });
  }

  /* ---------- PDP: gallery, variants, sticky ATC ---------- */
  function initProduct() {
    var form = document.querySelector('#ProductForm') || document.querySelector('.pdp__form');
    if (!form) return;

    // Gallery
    var mainImg = document.querySelector('[data-gallery-main]');
    on('[data-gallery-thumb]', 'click', function (e, thumb) {
      if (mainImg) { mainImg.src = thumb.getAttribute('data-full'); mainImg.alt = thumb.getAttribute('data-alt') || ''; }
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
    });

    // Variant data
    var variants = [];
    try { variants = JSON.parse(document.getElementById('ProductVariantsJSON').textContent); } catch (e) {}
    var selected = { color: null, size: null };
    var atcBtn = form.querySelector('[data-atc]');
    var atcPrice = form.querySelector('[data-atc-price]');
    var idInput = form.querySelector('[name="id"]');
    var stickyBtn = document.querySelector('[data-sticky-atc-btn]');

    function findVariant() {
      return variants.find(function (v) {
        var okColor = selected.color == null || v.option_color === selected.color;
        var okSize = selected.size == null || v.option_size === selected.size;
        return okColor && okSize;
      });
    }
    // Swap the main gallery image to the one assigned to a given variant.
    function setGalleryImage(src, alt) {
      if (!mainImg || !src || mainImg.src === src) return;
      mainImg.src = src;
      if (alt != null) mainImg.alt = alt;
      // keep thumbnail active state in sync if the variant image is a thumb
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.setAttribute('aria-current', t.getAttribute('data-full') === src ? 'true' : 'false');
      });
    }
    // First variant of a color that has an image (used before a size is picked).
    function imageForColor(color) {
      var v = variants.find(function (x) { return x.option_color === color && x.image; });
      return v || null;
    }
    function update() {
      var hasColor = document.querySelector('[data-opt-color]');
      var hasSize = document.querySelector('[data-opt-size]');
      var ready = (!hasColor || selected.color) && (!hasSize || selected.size);
      if (!ready) {
        atcBtn.textContent = 'Select Your Size';
        atcBtn.setAttribute('aria-disabled', 'true');
        if (stickyBtn) stickyBtn.textContent = 'Select Your Size';
        return;
      }
      var v = findVariant();
      if (!v || !v.available) {
        atcBtn.textContent = v ? 'Sold Out' : 'Unavailable';
        atcBtn.setAttribute('aria-disabled', 'true');
        return;
      }
      idInput.value = v.id;
      atcBtn.setAttribute('aria-disabled', 'false');
      atcBtn.textContent = 'Add to Cart — ' + money(v.price);
      if (atcPrice) atcPrice.textContent = money(v.price);
      if (stickyBtn) stickyBtn.textContent = 'Add to Cart — ' + money(v.price);
      if (v.image) setGalleryImage(v.image, v.image_alt);
    }

    on('[data-opt-color] .swatch-btn', 'click', function (e, btn) {
      selected.color = btn.getAttribute('data-value');
      btn.closest('[data-opt-color]').querySelectorAll('.swatch-btn').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      var lbl = document.querySelector('[data-color-label]'); if (lbl) lbl.textContent = selected.color;
      // Swap the gallery to this color's image right away, even before a size is picked.
      var cv = imageForColor(selected.color);
      if (cv) setGalleryImage(cv.image, cv.image_alt);
      update();
    });
    on('[data-opt-size] .size-chip', 'click', function (e, btn) {
      if (btn.disabled) return;
      selected.size = btn.getAttribute('data-value');
      btn.closest('[data-opt-size]').querySelectorAll('.size-chip').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      update();
    });

    // Submit -> add to cart drawer
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atcBtn.getAttribute('aria-disabled') === 'true') return;
      Cart.add(idInput.value, 1);
    });
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      if (atcBtn.getAttribute('aria-disabled') === 'true') {
        document.querySelector('[data-opt-size]').scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      Cart.add(idInput.value, 1);
    });

    // Sticky ATC visibility (<=768px): show after scrolling past main ATC
    var sticky = document.querySelector('[data-sticky-atc]');
    if (sticky && 'IntersectionObserver' in window) {
      document.body.classList.add('has-sticky-atc');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (window.innerWidth > 768) { sticky.classList.remove('is-visible'); return; }
          sticky.classList.toggle('is-visible', !en.isIntersecting);
        });
      }, { rootMargin: '0px 0px -40px 0px' });
      io.observe(atcBtn);
    }

    update();
  }

  /* ---------- Contact form success (after ?contact_posted=true) ---------- */
  function initContact() {
    var box = document.querySelector('[data-contact-success]');
    if (box && /contact_posted=true/.test(window.location.search)) box.hidden = false;
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncement();
    initMobileNav();
    Cart.init();
    initTabs();
    initAccordions();
    initProduct();
    initContact();
  });
})();
